const isNextDate = (todayString,dateTimeString) => {
    const today = new Date(todayString);
    const date = new Date(dateTimeString);

    // dateに1日を追加
    const nextDay = new Date(today);
    nextDay.setDate(today.getDate() + 1);

    // 年、月、日を比較（時間は無視）
    return date.getFullYear() === nextDay.getFullYear() &&
            date.getMonth() === nextDay.getMonth() &&
            date.getDate() === nextDay.getDate();
}

export default isNextDate;